import React, { useState } from "react";
import _ from "lodash";

export const ModalDialog = ({
  shouldShow,
  onClose,
  items,
  title,
  fields,
  onItemChange,
  onSave,
  onSelectAll,
  selectedItems,
}) => {
  const [isSelectedAll, setSelectAll] = useState(false);
  return shouldShow ? (
    <div
      className="modal"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn btn-light"
              onClick={onClose}
              aria-label="Close"
            >
              <span className="close">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  {fields.map((f) => (
                    <th>{_.startCase(f)}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="checkbox"
                      checked={isSelectedAll}
                      onChange={() => {
                        onSelectAll(!isSelectedAll);
                        setSelectAll(!isSelectedAll);
                      }}
                    />
                  </td>
                  <td>Select All</td>
                  {fields.map((f, i) => {
                    return i !== 0 && i !== fields.lenght - 1 ? (
                      <td></td>
                    ) : null;
                  })}
                </tr>
                {items.map((item) => {
                  return (
                    <tr key={item.id}>
                      <td>
                        <input
                          key={item.id}
                          type="checkbox"
                          checked={
                            selectedItems.find((i) => i.id === item.id)
                              ? true
                              : false
                          }
                          onChange={() => {
                            onItemChange(item);
                          }}
                        />
                      </td>
                      {fields.map((f) => (
                        <td>{item[f]}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
            <button type="button" className="btn btn-primary" onClick={onSave}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
